import React from "react";
import WideContainer from "../../components/WideContainer";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import InputBase from "@mui/material/InputBase";
import { withRouter } from "react-router";
import {
  Player,
  ControlBar,
  BigPlayButton,
  LoadingSpinner,
  PlayToggle,
  VolumeMenuButton,
  FullscreenToggle,
  CurrentTimeDisplay,
  DurationDisplay,
  ProgressControl,
} from "video-react";
import { Trans, withTranslation } from "react-i18next";

import QueryBuilder from "../../components/QueryBuilder";
import axios from "../../components/Axios";
import "./Queries.css";
import { connect } from "react-redux";

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.condition = {
      inclusion: true,
      char_id: -2,
      key: "",
      value: "",
    };
    this.group = {
      connection: "and",
      query_criterions_list: [{ ...this.condition }],
      query_states_list: [],
    };

    this.state = {
      selected: 0,
      items: [
        {
          project_id: this.props.project.project_id,
          query_name: "New Query Name 1",
          readonly: true,
          query_state: {
            connection: "and",
            query_criterions_list: [{ ...this.condition }],
            query_states_list: [],
          },
        },
      ],
      loading: false,
      loading_queries: false,
      loading_result: false,
      options: [],
      player: {
        duration: 0,
      },
    };
    this.sentenceRef = [];

    this.handleChange = this.handleChange.bind(this);
    this.addQuery = this.addQuery.bind(this);
    this.getItem = this.getItem.bind(this);
    this.saveItem = this.saveItem.bind(this);
    this.submitQuery = this.submitQuery.bind(this);
  }

  componentDidMount() {
    this.player.subscribeToStateChange(this.handleStateChange.bind(this));

    this.setState({ loading: true, loading_queries: true });
    //query list
    axios
      .get("/video_project/" + this.props.project.project_id + "/queries")
      .then(
        function (response) {
          this.setState({ loading_queries: false });
          if (response.data.length > 0) {
            for (var i in response.data) {
              response.data[i].readonly = true;
            }
            this.setState({ items: response.data });
            //this.getItem(this.state.selected);
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          this.setState({ loading_queries: false });
          console.log(error);
        }.bind(this)
      );

    //query options
    axios
      .get("/video_project/" + this.props.project.project_id + "/query_options")
      .then(
        function (response) {
          this.setState({ loading: false, options: response.data });
        }.bind(this)
      )
      .catch(
        function (error) {
          this.setState({ loading: false });
          console.log(error);
        }.bind(this)
      );
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.videosrc !== prevProps.videosrc) {
      this.player.load();
    }
  }
  handleStateChange(state) {
    // copy player state to this component's state
    this.setState({
      player: state,
    });
  }

  handleChange(p, o, e) {
    let v = e.target.value;
    let parts = p.split(".");
    // setState updaters must be pure (StrictMode runs them twice in dev),
    // so mutate a deep copy of the branch being changed instead of prev state
    let copy = (prev) => ({
      [parts[0]]: JSON.parse(JSON.stringify(prev[parts[0]])),
    });

    if (o === "add") {
      this.setState(function (prev) {
        let state = copy(prev);
        if (parts.length === 4)
          state[parts[0]][parts[1]][parts[2]][parts[3]].push({
            ...this.condition,
          });
        if (parts.length === 6)
          state[parts[0]][parts[1]][parts[2]][parts[3]][parts[4]][
            parts[5]
          ].push({
            ...this.condition,
          });
        return state;
      });
      return;
    }

    if (o === "addgroup") {
      this.setState(function (prev) {
        let state = copy(prev);
        if (parts.length === 4)
          state[parts[0]][parts[1]][parts[2]][parts[3]].push(
            JSON.parse(JSON.stringify(this.group))
          );
        //if(parts.length===5) state[parts[0]][parts[1]][parts[2]][parts[3]][parts[4]].push( JSON.parse(JSON.stringify(this.group)) );
        return state;
      });
      return;
    }

    if (o === "remove") {
      this.setState(function (prev) {
        let state = copy(prev);
        if (parts.length === 5)
          state[parts[0]][parts[1]][parts[2]][parts[3]].splice(
            parseInt(parts[4]),
            1
          );
        if (parts.length === 7)
          state[parts[0]][parts[1]][parts[2]][parts[3]][parts[4]][
            parts[5]
          ].splice(parseInt(parts[6]), 1);
        return state;
      });
      return;
    }

    //set value check
    if (v === undefined) return;

    //set value
    this.setState(function (prev) {
      let state = copy(prev);
      if (parts.length === 4) state[parts[0]][parts[1]][parts[2]][parts[3]] = v;
      if (parts.length === 6) {
        state[parts[0]][parts[1]][parts[2]][parts[3]][parts[4]][parts[5]] =
          parts[5] === "char_id" ? parseInt(v) : v;
        if (parts[5] === "key")
          state[parts[0]][parts[1]][parts[2]][parts[3]][parts[4]]["value"] = "";
        if (parts[5] === "char_id")
          state[parts[0]][parts[1]][parts[2]][parts[3]][parts[4]]["key"] = "";
      }

      if (parts.length === 8) {
        state[parts[0]][parts[1]][parts[2]][parts[3]][parts[4]][parts[5]][
          parts[6]
        ][parts[7]] = parts[7] === "char_id" ? parseInt(v) : v;
        if (parts[7] === "key")
          state[parts[0]][parts[1]][parts[2]][parts[3]][parts[4]][parts[5]][
            parts[6]
          ]["value"] = "";
        if (parts[7] === "char_id")
          state[parts[0]][parts[1]][parts[2]][parts[3]][parts[4]][parts[5]][
            parts[6]
          ]["key"] = "";
      }

      return state;
    });
  }

  addQuery() {
    this.setState({
      selected: this.state.items.length,
      items: [
        ...this.state.items,
        {
          project_id: this.props.project.project_id,
          query_name: "New Query Name 1" + (this.state.items.length + 1),
          readonly: true,
          query_state: {
            connection: "and",
            query_criterions_list: [{ ...this.condition }],
            query_states_list: [],
          },
        },
      ],
    });
  }

  editName(i) {
    this.setState(function (state) {
      state.items[i].readonly = false;
      return state;
    });
  }

  deleteQuery(i, e) {
    e.stopPropagation();

    let query = this.state.items[i];

    if ("query_id" in query) {
      // delete on server
      axios
        .delete("/query", { data: query })
        .then(
          function (response) {
            if (response.data.length > 0) {
              for (var i in response.data) {
                response.data[i].readonly = true;
              }
              this.setState({ items: response.data });
              //this.getItem(this.state.selected);
            } else {
              //set clean query
              this.setState({
                items: [
                  {
                    project_id: this.props.project.project_id,
                    query_name: "New Query Name 1",
                    readonly: true,
                    query_state: {
                      connection: "and",
                      query_criterions_list: [{ ...this.condition }],
                      query_states_list: [],
                    },
                  },
                ]
              });
            }
          }.bind(this)
        )
        .catch(
          function (error) {
            this.setState({ loading_queries: false });
            console.log(error);
          }.bind(this)
        );
    } else {
      //delete locally
      this.setState(function (state) {
        if (state.selected === state.items.length - 1)
          this.setActive(state.selected - 1);
        state.items.splice(i, 1);
        return state;
      });
    }
  }

  queryNameChange(i, e) {
    let v = e.target.value;
    this.setState(function (state) {
      state.items[i].query_name = v;
      return state;
    });
  }

  setActive(i) {
    if (i >= 0 && !("query_state" in this.state.items[i])) {
      //this.getItem(i);
    }
    this.setState({ selected: i });
  }

  getItem(i) {
    axios
      .get("/query/" + this.state.items[i].query_id)
      .then(
        function (response) {
          //this.setState({ loading_queries: false });
          this.setState(function (state) {
            state.items[i].query_state = response.data;
            return state;
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          //this.setState({ loading_queries: false });
          console.log(error);
        }.bind(this)
      );
  }

  saveItem(e) {
    axios({
      method:
        "query_id" in this.state.items[this.state.selected] ? "put" : "post",
      url: "/query",
      data: this.state.items[this.state.selected],
    })
      .then(
        function (response) {
          //this.setState({items: response.data});
          this.setState(function (state) {
            state.items[this.state.selected].readonly = true;
            return state;
          });
          //this.componentDidMount();
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          this.setState({ loading: false });
        }.bind(this)
      );
  }

  submitQuery(e) {
    this.setState({ loading_result: true });
    axios
      .post(
        "/video_project/" + this.props.project.project_id + "/query_search",
        this.state.items[this.state.selected].query_state
      )
      .then(
        function (response) {
          //this.setState({items: response.data});
          localStorage.setItem(
            "project/" + this.props.project.project_id + "/query_search",
            JSON.stringify(response.data)
          );
          localStorage.setItem(
            "project/" + this.props.project.project_id + "/query",
            JSON.stringify(this.state.items[this.state.selected].query_state)
          );
          localStorage.setItem(
            "project/" + this.props.project.project_id + "/queries",
            JSON.stringify(this.state.items)
          );
          this.setState({ loading_result: false });

          this.props.history.push("query_result");
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          if (error.response.status === 400) {
            alert(error.response.data.detail);
          }
          this.setState({ loading_result: false });
        }.bind(this)
      );
  }

  render() {
    return (<>
      <WideContainer style={{ paddingTop: "32px" }}>
        <div className="flex" style={{ alignItems: "stretch" }}>
          <div className="queryList">
            <div className="flex" style={{ paddingRight: "16px" }}>
              <div className="queryTitle"><Trans>Query builder</Trans></div>
              <Button
                variant="outlined"
                endIcon={<AddIcon />}
                onClick={this.addQuery}
              >
                <Trans>New Query</Trans>
              </Button>
            </div>
            <div style={{ marginTop: "24px" }}>
              {this.state.items.map((i, k) => (
                <div
                  className={
                    "flex queryRow" +
                    (k === this.state.selected ? " queryRowActive" : "")
                  }
                  key={k}
                  onClick={this.setActive.bind(this, k)}
                >
                  <div className="queryName">
                    <InputBase
                      value={i.query_name}
                      size="small"
                      className="queryInput"
                      readOnly={i.readonly}
                      onChange={this.queryNameChange.bind(this, k)}
                    ></InputBase>
                  </div>
                  <IconButton
                    color="primary"
                    onClick={this.editName.bind(this, k)}
                    disabled={!i.readonly}
                    size="large">
                    <EditIcon />
                  </IconButton>
                  <IconButton color="primary" onClick={this.deleteQuery.bind(this, k)} size="large">
                    <DeleteIcon />
                  </IconButton>
                </div>
              ))}
            </div>
          </div>
          <div style={{ flex: "1" }}>
            <div className="queryBuilder">
              {this.state.selected in this.state.items &&
                "query_state" in this.state.items[this.state.selected] && (
                  <>
                    <div style={{ flex: "1" }}>
                      <QueryBuilder
                        {...this.state.items[this.state.selected].query_state}
                        handleChange={this.handleChange}
                        path={"items." + this.state.selected + ".query_state"}
                        options={this.state.options}
                        loading={this.state.loading}
                        name={
                          this.state.items[this.state.selected].query_name
                        }
                      />
                    </div>
                    <div className="launchBar"></div>
                    <div className="flex">
                      <div style={{ flex: "1" }}></div>
                      <Button
                        className="Button ButtonPrimary"
                        size="small"
                        onClick={this.saveItem}
                        endIcon={<SaveIcon />}
                      >
                        <Trans>Save</Trans>
                      </Button>
                      <Button
                        className="Button ButtonPrimary"
                        size="small"
                        disabled={this.state.loading_result}
                        endIcon={<SearchIcon />}
                        style={{ margin: "0 24px" }}
                        onClick={this.submitQuery}
                      >
                        <Trans>Launch Query</Trans>
                      </Button>
                    </div>
                  </>
                )}
            </div>
            <div className="mainColumn queryVideoContainer">
              <Player
                ref={(player) => {
                  this.player = player;
                }}
                autoPlay={false}
                src={this.props.videosrc}
              >
                <BigPlayButton position="center" />
                <LoadingSpinner />
                <ControlBar autoHide={false} disableDefaultControls>
                  <PlayToggle key="play-toggle" order={1} />
                  <VolumeMenuButton
                    key="volume-menu-button"
                    order={4}
                    vertical
                  />
                  <CurrentTimeDisplay
                    key="current-time-display"
                    order={5.1}
                  />
                  <DurationDisplay key="duration-display" order={7.3} />
                  <ProgressControl key="progress-control" order={6} />
                  <FullscreenToggle key="fullscreen-toggle" order={8} />
                </ControlBar>
              </Player>
            </div>
          </div>
        </div>
      </WideContainer>
    </>);
  }
}

const mapState = (state) => {
  return {};
};
export default withTranslation()(withRouter(connect(mapState)(Index)));
